/* 
  Usage:
  <ia-accordion-component class="ia-accordion {% if forloop.first %}ia-accordion--expanded{% endif %}">
    <div class="ia-accordion__header" data-toggle-accordion>
      <h3>{{ block.settings.title }}</h3>
      <span class="ia-accordion__expand-icon iconic-button">
        {{ 'ia-icon-plus.svg' | inline_asset_content }}
        {{ 'ia-icon-minus.svg' | inline_asset_content }}
      </span>
    </div>
    <div class="ia-accordion__body">
      <div class="ia-accordion__content">
        {{ block.settings.answer }}
      </div>
    </div>
  </ia-accordion-component>
*/

if (!customElements.get('ia-accordion-component')) {
  class IaAccordionComponent extends HTMLElement {
    constructor () {
      super()
      this.body = this.querySelector('.ia-accordion__body')
      this.keepOthersOpen = this.dataset.keepOthersOpen === "true"
      this.querySelector('[data-toggle-accordion]').addEventListener('click', this.toggleAccordion.bind(this))
    }

    connectedCallback () {

    }

    toggleAccordion () {
      const section = this.closest('.shopify-section')
      const accordionItems = section ? section.querySelectorAll('ia-accordion-component') : [this]

      if (!this.classList.contains('ia-accordion--expanded')) {
        if (!this.keepOthersOpen) {
          accordionItems.forEach(accordion => {
            accordion.close()
          })
        }
        this.open()
      } else {
        this.close()
      }
    }

    open () {
      this.classList.add('ia-accordion--expanded')
    }

    close () {
      this.classList.remove('ia-accordion--expanded')
    }
  }

  customElements.define('ia-accordion-component', IaAccordionComponent)
} 